import React, { useEffect, useState } from 'react';
import { Nav, NavItem, NavLink } from 'reactstrap';
import { Link } from 'react-router-dom';
import KshemaLogo from '../assets/img/kshema_logo.svg';
import Image from 'react-bootstrap/Image';
import '../assets/style/SideNav.css';
import SubMenu from './SubMenu';
import {
  dashboardSelector,
  updateSelectedMenu,
  updateSideMenuStatus,
} from '../redux/slices/dashboardSlice';
import { LoggedUserType, SideMenuItemType } from '../utils/Types';
import { RABC } from '../utils/RBAC';
import { loginSelector, onLogout, setLocalLogout } from '../redux/slices/loginSlice';
import { SIDE_MENU_STATUS } from '../utils/Constant';
import CloseIcon from '../assets/img/close.svg';
import { ThunkDispatch } from 'redux-thunk';
import { useDispatch, useSelector } from 'react-redux';
import { isAPISuccess } from '../utils/Util';
import { toast } from 'react-toastify';
import oidcConfig, { userManager } from '../utils/AuthConfig';
import { UserManager } from 'oidc-client-ts';

const SideNav = () => {
  const [isOpen, setIsOpen] = useState(true);
  const dashboardState = useSelector(dashboardSelector);
  const user: LoggedUserType = useSelector(loginSelector).user;
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>();

  useEffect(() => {
    setIsOpen(dashboardState.isOpenSideMenu);
  }, [dashboardState.isOpenSideMenu]);
  const [showLoader, setShowLoader] = useState<boolean>(false);
  const dispatchLogout = useDispatch<ThunkDispatch<any, any, any>>();
  const callLogout = () => {
    setShowLoader(true);
    dispatch(setLocalLogout({}));
    userManager.signoutRedirect().then((response :any) => {
      console.log('Logout initiated', response);
      toast.success("Logged Out Successfully!");
    }).catch((error: any) => {
      console.error('Logout error:', error);
    });
  };
  const toggle = () => {
    //auto close side for mobile on selecting the
    if (window.innerWidth <= 1000) {
      setIsOpen(!isOpen);
      dispatch(updateSideMenuStatus(SIDE_MENU_STATUS.CLOSE));
    }
  };
  const dashboardItems = RABC.map((item: SideMenuItemType, index: number) => {
    return (
      <div key={`key-${item.route}`}>
        {item.submenu &&
          item.submenuItems &&
          item.permission &&
          user.permissions?.includes(item.permission) && (
            <SubMenu
              key={`submenu-${item.route}-${index}`}
              title={item.title}
              icon={item.icon}
              items={item.submenuItems}
              parentKey="user-onboarding"
              onSelected={toggle}
            />
          )}
        {(!item.submenu && item.permission && user.permissions?.includes(item.permission)) &&
          (
            <NavItem key={`${item.route}-${index}`}>
              <NavLink
                tag={Link}
                to={item.route}
                onClick={() => {
                  dispatch(updateSelectedMenu(item.route));
                  toggle();
                }}
                className={`align-middle ${
                  dashboardState.selectedMenu === item.route
                    ? 'nav-selected'
                    : 'nav-unselected'
                }`}
              >
                <Image src={item.icon} alt="icon" className="icon" />
                {item.title}
              </NavLink>
            </NavItem>
          )
        }
        { item.title === 'Logout' &&
          (
            <>
              <NavItem key={`${item.route}-${index}`}>
                <NavLink
                  tag={Link}
                  onClick={() => {
                    callLogout();
                  }}
                  className={`align-middle ${
                    dashboardState.selectedMenu === item.route
                      ? "nav-selected"
                      : "nav-unselected"
                  }`}
                >
                  <Image src={item.icon} alt="icon" className="icon" />
                  {item.title}
                </NavLink>
              </NavItem>
            </>
          )
      }
      </div>
    );
  });

  return (
    <div className={`sidenav ${isOpen ? 'open' : ''}`}>
      <div className="d-flex flex-row-reverse">
        <Image
          src={CloseIcon}
          className="close-icon align-self-end menu"
          onClick={toggle}
        />
      </div>
      <Nav vertical color="light" expand="md">
        <div className="text-center">
          <Image src={KshemaLogo} alt="img" className="logo-header" />
        </div>
        {dashboardItems}
      </Nav>
    </div>
  );
};

export default SideNav;
